import type { FormConfig } from "src/system/module.types.ts";
import type { FieldValues } from "react-hook-form";
import type { ValidParams } from "src/lib/react-router/types.ts";
import type {
  ValidFormData,
  ValidRequestData,
} from "src/components/Form/hooks/useResourceForm/useResourceForm.tsx";

export const fetchResourceFormConfig = async <
  FormValues extends FieldValues = FieldValues,
  Params extends ValidParams = ValidParams,
  FormData extends ValidFormData = ValidFormData,
  RequestData extends ValidRequestData = ValidRequestData,
>({
  action,
  resource,
  tab,
}: {
  action: "edit" | "create";
  resource: string;
  tab?: string;
}): Promise<FormConfig<FormValues, Params, FormData, RequestData>> => {
  const lists = import.meta.glob("../admin/forms/**/*.tsx");

  const importPath = `../admin/forms/${resource}/${action}/${action}.config.tsx`;
  const importPath2 = `../admin/forms/${resource}/${action}/${resource}.${action}.config.tsx`;

  const commonFormImportPath = !tab
    ? `../admin/forms/${resource}/config.tsx`
    : `../admin/forms/${resource}/tabs/${tab}/config.tsx`;

  const commonFormImportPath2 = !tab
    ? `../admin/forms/${resource}/${resource}.config.tsx`
    : `../admin/forms/${resource}/tabs/${tab}/${resource}.config.tsx`;

  if (Object.keys(lists).includes(importPath)) {
    return ((await lists[importPath]()) as any).config;
  }

  if (Object.keys(lists).includes(importPath2)) {
    return ((await lists[importPath2]()) as any).config;
  }

  if (Object.keys(lists).includes(commonFormImportPath)) {
    return ((await lists[commonFormImportPath]()) as any).config;
  }

  if (Object.keys(lists).includes(commonFormImportPath2)) {
    return ((await lists[commonFormImportPath2]()) as any).config;
  }

  throw new Error(
    `getFormConfig for ${resource} resource of ${action} action is not implemented`,
  );
};
